import React from 'react'

export const WaterFlash = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_1813)'>
      <path
        d='M5.636 6.636L12 0.272003L18.364 6.636C19.6227 7.89468 20.4798 9.49833 20.8271 11.2442C21.1743 12.99 20.9961 14.7996 20.3149 16.4441C19.6337 18.0886 18.4802 19.4942 17.0001 20.4832C15.5201 21.4721 13.78 21.9999 12 21.9999C10.22 21.9999 8.47992 21.4721 6.99988 20.4832C5.51984 19.4942 4.36628 18.0886 3.68509 16.4441C3.0039 14.7996 2.82566 12.99 3.17292 11.2442C3.52018 9.49833 4.37734 7.89468 5.636 6.636ZM13 11V6.5L8.5 13H11V17.5L15.5 11H13Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_1813'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
